import Api from './Api';
import axios from 'axios';
// https://api.ipapi.com/check?access_key=229c548dcafb9cff13041d9544ac60af
import jquery from 'jquery';
export default {
    SendLog(payload) {
        return Api().post(`/api/admin/insertlog`, payload);
    },
    GetIpDetails() {
        jquery.ajax({
            url: 'https://ipapi.co/json',
            method: "GET"
        })
            .then(function (ressss) {
                console.log('objectobjectobjectobjectobjectobject :');
            });
    },

    SendNotificationLog(payload) {
        return Api().post(`/api/admin/notificationlog`, payload);
    },

    GetAllNotification(payload) {
        return Api().get(`/api/admin/notificationlog?user_id=${payload.user_id}&limit=${payload.limit}&currentPage=${payload.currentPage}`);
    },

    UpdateNotificationStatus(payload) {
        return Api().put(`/api/admin/notificationlog`, payload);
    }
}


// WEBPACK FOOTER //
// ./src/services/LogService.js